class LocalStorageService {
  // 专门保存限时过期的池
  constructor() {
    this.expire_pool = JSON.parse(window.localStorage.getItem('expire_pool')) || {}
  }

  updateExpirePool() {
    window.localStorage.setItem('expire_pool', JSON.stringify(this.expire_pool))
  }

  /**
   * 保存数据
   * @param key
   * @param value
   * @param expire_time 有效期，单位（秒）
   */
  set(key, value, expire_time) {
    if (expire_time && expire_time > 0) {
      const current_time = new Date().getTime()
      expire_time = current_time + expire_time * 1000
      this.expire_pool[key] = expire_time
      this.updateExpirePool();
    }
    window.localStorage.setItem(key, value)
  }

  setObj(key, value, expire_time) {
    // this.set(key, JSON.stringify(value), expire_time)
    this.set(key, JSON.stringify(value), expire_time)
  }

  /**
   * 获取数据
   * @param key
   * @returns {string | null}
   */
  get(key) {
    const item = this.expire_pool[key];
    if (item) {
      const expire_time = item.expire_time
      const current_time = new Date().getTime()
      if (current_time >= expire_time) {
        this.remove(key)
      } else {
        return window.localStorage.getItem(key)
      }
    }
    return window.localStorage.getItem(key)
  }

  /**
   * 获取对象
   * @param key
   */
  getObj(key) {
    var text = this.get(key);
    if (text && text != 'undefined') {
      return JSON.parse(text);
    }
    return {}
  }

  /**
   * 移除数据
   * @param key
   */
  remove(key) {
    window.localStorage.removeItem(key)
  }

  /**
   * 清理过期的数据
   */
  clearExpire() {
    for (let key in this.expire_pool) {
      const expire_time = this.expire_pool[key]
      const current_time = new Date().getTime()
      if (current_time >= expire_time) {
        this.remove(key)
        delete this.expire_pool[key]
        this.updateExpirePool();
      }
    }
  }
}

const localStorage = new LocalStorageService();

export default localStorage
